import React from "react";

import moment from 'moment'
import { framework_tool, component_tool } from "@/tool";
import { WizClassifySelect, WizTableForm } from '@/containers/common';
const labelConfig = WizTableForm.Config.label(this, { apiParams: { type: 6 } })
const { ossFileUtils } = framework_tool
const { WizModal } = component_tool
import HighSet from "@/containers/common/highSet";

//配置项
let componentName = "contentManage";

const hiddenTypeEnum = {
  content: 0,
  learningMaterials: 1,
}, hiddenTypeToCategoryEnum = {
  content: 5,
  learningMaterials: 17,
}, categoryStrEnum = {
  content: '内容分类',
  learningMaterials: '分类',
}

const columns = (hiddenType) => {
  return [
    {
      name: "id",
    },
    {
      title: "封面",
      name: "filePath",
      dataIndex: "filePath",
      tableItem: {
        render: (text, record) => <div style={{height:32}}>
          {/*<img src={ossFileUtils.getOssImgResizeUrl(record.fileUri, { m: 'fill', w: 60, h: 32 })} />*/}
          {record.img ? <img width={60} height={32} src={getOssFilePath(record.img)}/> : null}
        </div>
      },
    },
    {
      title: "标题",
      name: "title",
      dataIndex: "title",
      searchItem: {},
      tableItem: {},
    },
    hiddenType === 'content' ? {
      title: "标签",
      name: "labelNames",
      dataIndex: "labelNames",
      tableItem: {},
    } : null,
    {
      title: categoryStrEnum[hiddenType],
      name: "categoryIds",
      dataIndex: "categoryIds",
      searchItem: {
        type: 'diy',
        diy: WizClassifySelect,
        returnKey: true,
        wizTreeSelectListProps: {
          itemProps: {
            icon: 'unordered-list',
            title: categoryStrEnum[hiddenType],
            tips: '请勾选所属' + categoryStrEnum[hiddenType]
          },
          treeProps: { checkStrictly: true }
        },
        apiProps: { type: hiddenTypeToCategoryEnum[hiddenType] },
        selectProps: {
          placeholder: '请选择' + categoryStrEnum[hiddenType]
        },
      },
    },
    {
      title: categoryStrEnum[hiddenType],
      name: "categoryNames",
      dataIndex: "categoryNames",
      tableItem: {
        width: 240
      },
    },
    {
      title: "内容类型",
      name: "contentType",
      dataIndex: "contentType",
      tableItem: {},
      searchItem: {
        type: "select",
      },
      dict: [
        { code: 1, codeName: "文章" },
        { code: 2, codeName: "图片" },
        { code: 3, codeName: "视频" },
        hiddenType === 'learningMaterials' ? { code: 4, codeName: "文档" } : null,
        hiddenType === 'content' ? { code: 5, codeName: "下载" } : null,
      ].filter(item => !!item),
    },
    {
      title: "作者",
      name: "author",
      dataIndex: "author",
      tableItem: {},
    },
    {
      title: "发布平台",
      name: "releasePlatform",
      dataIndex: "releasePlatform",
      tableItem: {
        render: (text, record) => {
          const map = { '1': "PC", '2': 'APP', '3': '凯迪拉克IQ', '4': '小程序', '5' : '雪佛兰企微', '6' : '别克企微', '7' : '凯迪拉克企微'}
          const textArr = text.split(',');
          const arr = [];
          for (let index = 0; index < textArr.length; index++) {
            arr.push(map[textArr[index]])
          }
          return arr.join(',')
        }
      },
      dict: [
        { code: '1', codeName: "PC" },
        { code: '2', codeName: "APP" },
        { code: '3', codeName: "凯迪拉克IQ" },
        { code: '4', codeName: "小程序" },
        {code: '5', codeName: '雪佛兰企微'},
        {code: '6', codeName: '别克企微'},
        {code: '7', codeName: '凯迪拉克企微'},
      ],
      searchItem: {
        type: "select",
      },
    },
    {
      title: "状态",
      name: "releaseState",
      dataIndex: "releaseState",
      tableItem: {},
      dict: [
        { code: 0, codeName: "草稿" },
        { code: 1, codeName: "已发布" },
        { code: 2, codeName: "取消发布" },
        { code: 3, codeName: "已关闭" },
      ],
      searchItem: {
        type: "select",
      },
    },
    {
      title: "是否置顶",
      name: "switchTop",
      dataIndex: "switchTop",
      tableItem: {},
      dict: [
        { code: 1, codeName: "是" },
        { code: 0, codeName: "否" },
      ],
      searchItem: {
        type: "select",
      },
    },
    {
      title: "发布时间",
      name: "releaseTime",
      dataIndex: "releaseTime",
      tableItem: {
        width: 300,
        align: "center",
      },
      searchItem: {
        type: "date~",
        showTime: true,
      },
    },
    hiddenType === 'content' ? {
      title: '标签',
      name: 'labelIds',
      searchItem: {
        ...labelConfig,
        diy: WizTableForm,
      },
    } : null,
  ].filter(item => !!item)
};

const templateConfig = (hiddenType) => {
  return  {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns(hiddenType),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.releaseTime && value.releaseTime.length === 2) {
              value.releaseTimeStart = moment(value.releaseTime[0]).format('YYYY-MM-DD HH:mm:ss')
              value.releaseTimeEnd = moment(value.releaseTime[1]).format('YYYY-MM-DD HH:mm:ss')
            }
            // delete value.time
            return value
          },
          buttonSort: ['add', "delete", 'export'],
          buttons: [
            {
              key: "add",
              custom: true,
              params: { icon: "plus", children: "新增", type: "primary" },
              customOnClick: {
                key: "jumpPage",
                params: {
                  key: "push",
                  pathname: {
                    content: "/content/contentManage/contentDetailAdd",
                    learningMaterials: "/content/learningMaterialsManage/learningMaterialsDetailAdd",
                  }[hiddenType]
                }
              }
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ["look", "close", "update", "preview", "releaseOrUnpublish", "topOrCancelTop", "recordManagement", "advancedSet"],
        rowOperateView: [
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: {
                  content: "/content/contentManage/view",
                  learningMaterials: "/content/learningMaterialsManage/view",
                }[hiddenType],
              },
            },
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: {
                  content: "/content/contentManage/contentDetailUpd",
                  learningMaterials: "/content/learningMaterialsManage/learningMaterialsDetailUpd",
                }[hiddenType],
              },
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.releaseState !== 0 && record.releaseState !== 2;
              return { disabled: is, hidden: is }
            },
          },
          {
            key: "preview",
            custom: true,
            params: { children: "预览" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: {
                  content: "/content/contentManage/preview",
                  learningMaterials: "/content/learningMaterialsManage/preview",
                }[hiddenType],
              },
            },
          },
          {
            key: "releaseOrUnpublish",
            custom: true,
            params: { children: "发布" },
            textFormat: {
              recordKey: 'releaseState',
              dirt: { 0: '发布', 1: '取消发布', 2: '发布' }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let statusNameStr;
                switch (record['releaseState']) {
                  case 0:
                  case 2:
                    statusNameStr = '发布'
                    break;
                  case 1:
                    statusNameStr = '取消发布'
                    break;
                  default:
                    statusNameStr = ''
                    return null
                }
                const content = `您确定要` + statusNameStr + `该内容吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      releaseState: record['releaseState'] === 0 || record['releaseState'] === 2 ? 1 : 2,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.releaseState === 3;
              return { disabled: is, hidden: is }
            },
          },
          {
            key: "topOrCancelTop",
            custom: true,
            params: { children: "置顶" },
            textFormat: {
              recordKey: 'switchTop',
              dirt: { 1: '取消置顶', 0: '置顶', }
            },
            recordChangeParams: ({ record, rows }) => {
              let result = { disabled: false };
              if (record['releaseState'] !== 1) {
                result['disabled'] = true
              }
              return result
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "changeTop",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['switchTop'] === 0 ? "置顶" : "取消置顶"
                }该条内容吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "recordManagement",
            custom: true,
            params: { children: "记录管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: {
                  content: "/content/contentManage/record",
                  learningMaterials: "/content/learningMaterialsManage/record",
                }[hiddenType],
              },
            },
          },
          {
            key: 'advancedSet',
            custom: true,
            params: {children: '高级设置'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{record: e.record,bizType: 20}}
                               changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = false
              if (record && (record['releaseState'] !== 1
                || (hiddenType === 'content' && record.categoryNames && !record.categoryNames.includes("公告通知") && !record.categoryNames.includes("天天学练")))
              ) {
                disabled = true
              }
              return {disabled}
            }
          },
          {
            key: 'close',
            custom: true,
            params: { children: '关闭' },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "enable",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要关闭该内容吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      releaseState: 3,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.releaseState != 1;
              if(hiddenType === 'learningMaterials') {
                is = [1, 2].indexOf(record.releaseState) === -1
              }

              return { disabled: is, hidden: is }
            },
          },
        ],
        commonOperate: {
          add: true,
          delete: true,
          update: true,
        }
      },
    },
  }
};

const apis = (hiddenType) => {
  return {
    list: {
      path: `${componentName}/listByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {
          hiddenType: hiddenTypeEnum[hiddenType],
        },
      },
    },
    changeTop: {
      path: `${componentName}/changeTop`,
      payload: {
        key: `${componentName}@changeTop`,
        apiParams: {}
      }
    },
    enable: {
      path: `${componentName}/enable`,
      payload: {
        key: `${componentName}@enable`,
        apiParams: {},
      },
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {},
      },
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: {
          hiddenType: hiddenTypeEnum[hiddenType],
        }
      }
    }
  }
};

let reduxTemplateConfig = (args) => {
  let {hiddenType} = args;

  return {
    apis: apis(hiddenType),
    componentName,
    initApiKeys: ["list"],
    needLoading: true,
    keepInitApiParams:true,
    ...args,
  };
};

export { reduxTemplateConfig, templateConfig };
